module.exports = __webpack_public_path__ + "static/img/10.eff91f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/10.jpg
// module id = umwa
// module chunks = 0